export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 60 * 60;
export const SECONDS_PER_DAY = 60 * 60 * 24;

function pluralize(count: number, unit: string) {
  return `${count} ${unit}${count === 1 ? '' : 's'}`;
}

export function largestExactUnit(secs: number) {
  if (!(secs % SECONDS_PER_DAY)) return SECONDS_PER_DAY;
  if (!(secs % SECONDS_PER_HOUR)) return SECONDS_PER_HOUR;
  return SECONDS_PER_MINUTE;
}

export function formatDuration(secs: number) {
  const unit = largestExactUnit(secs);
  const unitName =
    unit === SECONDS_PER_DAY
      ? 'day'
      : unit === SECONDS_PER_HOUR
        ? 'hour'
        : 'minute';
  return pluralize(secs / unit, unitName);
}
